import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPlanDetailsWidgetStyles = isLargeScreen => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    outerContainer: {
      maxWidth: 598,
      width: '100%'
    },
    title: {
      paddingTop: spacing.SPACING_8
    },
    infotag: {
      marginBottom: spacing.SPACING_20
    },
    multiInfoTagsContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    multiInfoTags: {
      marginTop: spacing.SPACING_10
    },
    plantitle: {
      marginBottom: spacing.SPACING_12
    },
    packDetailListItem: {
      paddingBottom: spacing.SPACING_12
    },
    paddingRight: {
      paddingRight: spacing.SPACING_28
    },
    container: {
      paddingTop: isLargeScreen ? spacing.SPACING_24 : spacing.SPACING_20,
      paddingBottom: spacing.SPACING_12
    },
    button: {
      maxWidth: 287
    },
    addOnWidget: {
      paddingTop: isLargeScreen ? spacing.SPACING_24 : spacing.SPACING_20
    },
    addOnWidgetItemLast: {
      flex: 1
    },
    addOnWidgetItem: {
      marginRight: isLargeScreen ? spacing.SPACING_24 : spacing.SPACING_16,
      flex: 1
    },
    addOnTitle: {
      marginBottom: spacing.SPACING_12
    }
  });
};